// ** Components
import NewsCard from './NewsCard';
import CardCarousel from '@/components/common/carousel/CardCarousel';

// ** Types
import type { UploadFile } from '@/types/graphql';
import type { AppContext } from '@/types/contextTypes';
import type { SxProps, Theme } from '@mui/material/styles';
import type { CardCarouselCardsPerView } from '@/components/common/carousel/CardCarousel';

export type NewsCarouselItem = {
	title: string;
	description?: string | null;
	imageData?: UploadFile | null;
	imageUrl?: string | null;
	host: AppContext['host'];
	slug: string;
	publishedAt?: string | null;
	typeLabel?: string | null;
	ctaLabel?: string;
	basePath: string;
};

export type NewsCarouselProps = {
	items: NewsCarouselItem[];
	title?: string;
	showTitle?: boolean;
	ctaLabel?: string;
	ctaHref?: string;
	showCta?: boolean;
	cardsPerView?: CardCarouselCardsPerView;
	showArrowControls?: boolean;
	prevAriaLabel?: string;
	nextAriaLabel?: string;
	sx?: SxProps<Theme>;
	basePath?: string;
};

const NewsCarousel = ({
	items,
	title = 'Aktuelle News',
	showTitle = false,
	ctaLabel = 'Alle News',
	ctaHref,
	showCta = false,
	cardsPerView = { xs: 1.2, md: 3.2 },
	showArrowControls = true,
	prevAriaLabel = 'Vorherige News',
	nextAriaLabel = 'Naechste News',
	sx
}: NewsCarouselProps) => (
	<CardCarousel
		items={items}
		getItemKey={(card) => card.slug}
		cardsPerView={cardsPerView}
		renderItem={(card) => (
			<NewsCard
				title={card.title}
				description={card.description}
				imageData={card.imageData}
				imageUrl={card.imageUrl}
				host={card.host}
				slug={card.slug}
				publishedAt={card.publishedAt}
				typeLabel={card.typeLabel}
				ctaLabel={card.ctaLabel}
				basePath={card.basePath}
				fluidWidth
			/>
		)}
		title={title}
		showTitle={showTitle}
		ctaLabel={ctaLabel}
		ctaHref={ctaHref}
		showCta={showCta}
		spaceBetween={4}
		indicatorCount={3}
		showArrowControls={showArrowControls}
		prevAriaLabel={prevAriaLabel}
		nextAriaLabel={nextAriaLabel}
		sx={sx}
	/>
);

export default NewsCarousel;
